<template>
  <div class="relative">
    <BackButton :url="routes.getLatestTransfersPage()" />
    <NftsPageSummary class="mt-4" />
    <hr class="my-4 bg-primary opacity-20">
    <NftsPageTabs class="relative z-10 mb-4" />
    <div class="flex flex-col gap-y-2">
      <NuxtPage />
    </div>
  </div>
</template>

<script setup lang="ts">
import NftsPageSummary from '~/components/@pages/nfts/[address]/NftsPageSummary.vue'
import NftsPageTabs from '~/components/@pages/nfts/[address]/NftsPageTabs.vue'
import BackButton from '~/components/button/BackButton.vue'
import { getRouteParam } from '~/utils/route.util'

const address = getRouteParam('address')

const ellipsisAddress = computed(() => {
  return `${address.slice(0, 8)}...${address.slice(-6)}`
})

useSeoMeta(getMeta(`NFT ${ellipsisAddress.value}`, `Explore details of NFT ${ellipsisAddress.value}`))
</script>

<style scoped lang="scss">

</style>
